import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Progressor } from 'src/modules/utils/misc/Progressor';
import { Utils } from 'src/modules/utils/shared/utils';
import { DhTools } from '../../models/dh-tools.model';
import { Wrapper } from 'src/modules/utils/misc/wrapper.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';

@Component({
  selector: 'app-document-handler-tools',
  templateUrl: './document-handler-tools.component.html',
  styleUrls: ['./document-handler-tools.component.scss']
})
export class DocumentHandlerToolsComponent extends ComponentView {

    _Utils = Utils;

    app = inject(MainAppService);

    progressor = new Wrapper<Progressor>();

    async initParams(): Promise<boolean> {
        return Promise.resolve(true);
    }

    async openPersistentStorage(): Promise<void> {
        await DhTools.backendCall("api/dh/openPersistentStorage").getText();
    }

    async grantAllFileSystemRights(): Promise<void> {
        DhTools.startProgressor(this.progressor, await DhTools.backendCall("api/dh/grantAllFileSystemRights").getText());
    }

    async zipLogFiles(): Promise<void> {
        let year = await this.app.messageDialog.input(new FrontendFieldDefinition("year", "Jahr", FrontendFieldType.int, { mandatory: true, value: new Date().getFullYear() - 1}), "Welches Jahr soll gezipped werden?");
        if (year != null) {
            await DhTools.backendCall("api/dh/zipLogFiles", { year }).getText();
        }
    }

    async interpretEnaioErrorMessage(): Promise<void> {
        let data = await this.app.messageDialog.formGetObject(new FrontendFormDefinition([
            new FrontendFieldDefinition("message", "Fehlermeldung", FrontendFieldType.textArea, { mandatory: true }),
            new FrontendFieldDefinition("responseResult", "ResultCode", FrontendFieldType.int, { value: 0, mandatory: true })
         ]), "Eingabe");
        this.app.messageDialog.textArea("Ergebnis", await DhTools.backendCall("api/dh/interpretEnaioErrorMessage", data).getText());        
    }

}
